import { createSelector } from "@reduxjs/toolkit";

const selectFirstName = (state) => {
  return state.myProfile.profileData.firstName;
};
const selectLastName = (state) => {
  return state.myProfile.profileData.lastName;
};
const selectMiddleName = (state) => {
  return state.myProfile.profileData.middleName;
};
const selectEmail = (state) => {
  return state.myProfile.profileData.email;
};
const selectPhoneNumber = (state) => {
  return state.myProfile.profileData.telephoneNumber;
};
const selectUserName = (state) => {
  return state.myProfile.profileData.userName;
};
const selectDob = (state) => {
  return state.myProfile.profileData.dob;
};
const selectPreferredVerificationMethod = (state) => {
  return state.myProfile.profileData.preferredVerificationMethod;
};
const selectEmailLanguage = (state) => {
  return state.myProfile.profileData.emailLanguage;
};

const selectChangePrefMethodDescription = (state) => {
  return state.myProfile.changePrefMethodDescription;
};

const selectRemoveVerificationMethodDescription = (state) => {
  return state.myProfile.removeVerificationMethodDescription;
};
const selectApplicationStatus = (state) => {
  return state.myProfile.applicationStatus;
};

const selectIsUnreadNotice = (state) => {
  const unReadNotice = state.myProfile?.messageCenter?.find((notice) => {
    return notice.readStatus === false;
  });
  return !!unReadNotice;
};

const selectAddEditEmailLanguage = (state) => {
  return state.myProfile.profileData.addEditEmailLanguage;
};

const selectAssociatedLocationsData = (state) => {
  return state.myProfile.associatedLocationsData;
};

const selectIsUnreadNotification = (state) => {
  return !!state?.myProfile?.unreadMessageCount;
};

export const manageMyProfileSelector = createSelector(
  [
    selectFirstName,
    selectLastName,
    selectEmail,
    selectAddEditEmailLanguage,
    selectPhoneNumber,
    selectUserName,
    selectDob,
    selectPreferredVerificationMethod,
    selectMiddleName,
    selectChangePrefMethodDescription,
    selectRemoveVerificationMethodDescription,
    selectApplicationStatus,
    selectIsUnreadNotice,
    selectEmailLanguage,
    selectAssociatedLocationsData,
    selectIsUnreadNotification,
  ],
  (
    firstName,
    lastName,
    email,
    addEditEmailLanguage,
    phoneNumber,
    userName,
    dob,
    preferredVerificationMethod,
    middleName,
    changePrefMethodDescription,
    removeVerificationMethodDescription,
    applicationStatus,
    isUnReadNotice,
    emailLanguage,
    associatedLocationsData,
    isUnreadNotification
  ) => ({
    firstName,
    lastName,
    email,
    addEditEmailLanguage,
    phoneNumber,
    userName,
    dob,
    preferredVerificationMethod,
    middleName,
    changePrefMethodDescription,
    removeVerificationMethodDescription,
    applicationStatus,
    isUnReadNotice,
    emailLanguage,
    associatedLocationsData,
    isUnreadNotification,
  })
);
